import { Controller } from 'react-hook-form';
import { IconLoader, Select, SelectSize, SelectType } from '@ui/src';
import StepPartBlock from './step-part-block';
import InfoRow from './info-row';
import { NewApplicationStatus } from '../../../hoc/common/types';
import { ProductsTypes } from './types';

import commonStyles from './styles.module.css';

const Products = ({
  control,
  products,
  clearErrors,
  errors,
  status,
  isEditable,
  zIndex,
  infoDictionariesIsLoading,
}: ProductsTypes) => {
  let content;

  if (infoDictionariesIsLoading) {
    content = (
      <div className={commonStyles.dictionaryLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        <Controller
          control={control}
          name="productIds"
          render={({ field: { value } }) => (
            <input type="hidden" value={value} name="productIds" />
          )}
        />
        <InfoRow title="Products" id="productIds" lessPadding>
          <Controller
            control={control}
            name="productIds"
            defaultValue={[]}
            render={({ field: { onChange, value } }) => (
              <Select
                name="productIds"
                placeholder="Select products"
                list={products}
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['productIds', 'products']);
                }}
                mode={SelectType.MULTIPLE}
                error={errors?.productIds?.message || errors?.products?.message}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                borderless
              />
            )}
          />
        </InfoRow>
      </>
    );
  }

  return (
    <StepPartBlock title="Products & Services" zIndex={zIndex}>
      {content}
    </StepPartBlock>
  );
};

export default Products;
